export default "__VITE_ASSET__BP7v4eDa__"